export default defineNuxtPlugin(async () => {
  const route = useRoute()
  const userStore = useUserStore()
  const { mhjEnvironment } = useSiteUrl()
  const isProd = (mhjEnvironment ?? '').toLowerCase().includes('prod')

  // IMPORTANT: This plugin should be disabled on production
  if (isProd) return

  const syncShopperContext = async () => {
    await useShopperContext().createOrUpdateContext(route.query.siteDate, route.query.customerGroup)
  }

  await syncShopperContext()

  // Watch for changes in route query parameters
  watch(
    () => [route.query.siteDate, route.query.customerGroup],
    async ([newSiteDate, newCustomerGroup], [oldSiteDate, oldCustomerGroup]) => {
      if (newSiteDate !== oldSiteDate || newCustomerGroup !== oldCustomerGroup) {
        await syncShopperContext()
      }
    },
  )

  // Watch for changes in the user's customerId
  watch(
    () => userStore.user?.customerId,
    async (newCustomerId, oldCustomerId) => {
      if (newCustomerId && newCustomerId !== oldCustomerId) {
        await syncShopperContext()
      }
    },
  )
})
